/**
 * Timed Accordion — view.js
 *
 * Drives the progress-bar animation (scaleX 1 → 0) and auto-advances
 * accordion items on a configurable timer. Click on any trigger jumps to
 * that item and resets the countdown.
 */

document.querySelectorAll( '.timed-accordion' ).forEach( ( accordion ) => {

    const timerSeconds = parseFloat( accordion.dataset.timer ) || 6;
    const duration     = timerSeconds * 1000; // ms

    const items      = Array.from( accordion.querySelectorAll( '.timed-accordion__item' ) );
    const mediaItems = Array.from( accordion.querySelectorAll( '.timed-accordion__media-item' ) );

    let currentIndex = 0;
    let startTime    = null;
    let rafId        = null;

    // ── Helpers ───────────────────────────────────────────────────────────────

    function getActiveBar() {
        return items[ currentIndex ]
            ? items[ currentIndex ].querySelector( '.timed-accordion__progress-bar' )
            : null;
    }

    function deactivate( index ) {
        const item  = items[ index ];
        const media = mediaItems[ index ];
        if ( ! item ) return;

        item.classList.remove( 'is-active' );
        item.querySelector( '.timed-accordion__trigger' )
            .setAttribute( 'aria-expanded', 'false' );
        item.querySelector( '.timed-accordion__body' ).hidden = true;

        const bar = item.querySelector( '.timed-accordion__progress-bar' );
        bar.style.transition = 'none';
        bar.style.transform  = 'scaleX(0)';

        if ( media ) {
            media.classList.remove( 'is-active' );
            media.hidden = true;
        }
    }

    function activate( index ) {
        const item  = items[ index ];
        const media = mediaItems[ index ];
        if ( ! item ) return;

        currentIndex = index;

        item.classList.add( 'is-active' );
        item.querySelector( '.timed-accordion__trigger' )
            .setAttribute( 'aria-expanded', 'true' );
        item.querySelector( '.timed-accordion__body' ).hidden = false;

        // Reset bar to full immediately (no transition) then let rAF animate down.
        const bar = item.querySelector( '.timed-accordion__progress-bar' );
        bar.style.transition = 'none';
        bar.style.transform  = 'scaleX(1)';

        if ( media ) {
            media.hidden = false;
            // Trigger fade-in by re-adding is-active after a frame.
            media.classList.remove( 'is-active' );
            requestAnimationFrame( () => media.classList.add( 'is-active' ) );
        }

        // Videos: restart when shown.
        if ( media ) {
            const video = media.querySelector( 'video' );
            if ( video ) { video.currentTime = 0; video.play(); }
        }
    }

    function advance() {
        const next = ( currentIndex + 1 ) % items.length;
        deactivate( currentIndex );
        activate( next );
        startTimer();
    }

    // ── rAF timer loop ────────────────────────────────────────────────────────

    function startTimer() {
        if ( rafId ) cancelAnimationFrame( rafId );
        startTime = null;

        const bar = getActiveBar();
        if ( ! bar ) return;

        function tick( timestamp ) {
            if ( ! startTime ) startTime = timestamp;

            const elapsed  = timestamp - startTime;
            const progress = Math.min( elapsed / duration, 1 );
            const scale    = 1 - progress;

            bar.style.transition = 'none';
            bar.style.transform  = `scaleX(${ scale })`;

            if ( progress < 1 ) {
                rafId = requestAnimationFrame( tick );
            } else {
                rafId = null;
                advance();
            }
        }

        rafId = requestAnimationFrame( tick );
    }

    // ── Click handlers ────────────────────────────────────────────────────────

    items.forEach( ( item, index ) => {
        item.querySelector( '.timed-accordion__trigger' )
            .addEventListener( 'click', () => {
                if ( index === currentIndex ) return; // already active
                if ( rafId ) cancelAnimationFrame( rafId );
                deactivate( currentIndex );
                activate( index );
                startTimer();
            } );
    } );

    // ── Init ──────────────────────────────────────────────────────────────────

    // Ensure only the first item starts active (PHP sets this, but be safe).
    items.forEach( ( item, i ) => {
        if ( i !== 0 ) deactivate( i );
    } );
    activate( 0 );
    startTimer();

} );
